import {normalizeMargin} from './margin'
import {normalizePadding} from './padding'

export default {
    normalizeMargin,
    normalizePadding
}
